import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function LatestUpdate() {
  const latest = [...comics].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  ).slice(0, 8);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">每日同步更新，追更不等待</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
        >
          更多新作 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div
        className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5"
        data-product-shop=""
      >
        {latest.map((comic) => (
          <ComicCard
            key={comic.id}
            id={comic.id}
            title={comic.title}
            cover={comic.cover}
            rating={comic.rating}
            category={comic.category}
            chapters={comic.chapters}
            status={comic.status}
            views={comic.views}
            tags={comic.tags}
          />
        ))}
      </div>
    </section>
  );
}